import type { CatalogConfigProps } from './DefaultCatalogConfig';
import DefaultCatalogConfig, { IMAGE_DISABLED } from './DefaultCatalogConfig';

export default class CollectionsCatalogConfig extends DefaultCatalogConfig {
  constructor(props: CatalogConfigProps) {
    super(props);

    this.newCategory = this.editable;
    this.allowHoverActions = props.isEditorForCurrentMarket;
    this.item.copy = this.editable;
    this.item.remove = this.editable;
    this.item.cut = this.editable;

    this.allowCopyCategory = this.editable;
    this.allowRanking = !props.isGlobalMarket && props.isEditorForCurrentMarket;
    this.moveDisabled = false;
    this.category.productImage = IMAGE_DISABLED;
    this.category.categoryType =
      props.isGlobalMarket && props.isEditorForCurrentMarket;

    this.catalog.translation =
      !props.isGlobalMarket && props.isEditorForCurrentMarket;
  }
}
